// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"EditUsuario_cardContent__1FHqO","editUsuario":"EditUsuario_editUsuario__2JneY","form":"EditUsuario_form__1NaGu"};